import React from "react";
import { Link } from "react-scroll";

const ToTop = () => {
  return (
    <>
      <Link
        to="toTop"
        smooth={true}
        duration={500}
        id="toTop"
        style={{ opacity: 1, visibility: "visible", bottom: "130px" }}
      >
        <span className="ti-angle-up"></span>
      </Link>
    </>
  );
};

export default ToTop;
